import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import UpdateBanner from './components/UpdateBanner';

const root = ReactDOM.createRoot(document.getElementById('root'));

let showUpdateBanner = null;

root.render(<App />);

/* --- Service Worker Logic Disabled ---
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(registration => {
        registration.onupdatefound = () => {
          const newWorker = registration.installing;
          newWorker.onstatechange = () => {
            if (
              newWorker.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              showUpdateBanner = () => {
                root.render(
                  <>
                    <App />
                    <UpdateBanner onReload={() => {
                      newWorker.postMessage('SKIP_WAITING');
                      window.location.reload();
                    }} />
                  </>
                );
              };
              showUpdateBanner();
            }
          };
        };
      });
  });
}
*/